export default __webpack_public_path__ + "static/media/grant.2fec2242.wav";